import './App.css';
import Notification from './components/Block';
import picture from './assets/img/icon-calc.png'; // Иконка рассчета

function App() {
  return (
    <Notification picture={picture}/>
  );

}


export default App;
